import { render, staticRenderFns } from "./acumulado.vue?vue&type=template&id=604faf22&lang=pug&"
import script from "./acumulado.vue?vue&type=script&lang=js&"
export * from "./acumulado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports